<script setup lang="ts">
import { useRouter } from 'vue-router';
import { IonIcon } from '@ionic/vue';
import { chevronBackOutline } from 'ionicons/icons';
import { PropType } from 'vue';

const props = defineProps({
	icon: { type: String, default: '' },
	to: { type: String, default: '' },
	iconClass: { type: String, default: 'text-white' },
	onClick: { type: Function as PropType<(() => void) | undefined> },
});

const router = useRouter();

const handleClick = () => {
	if (props.onClick) {
		props.onClick();
	} else if (props.to) {
		router.push(props.to);
	} else {
		router.back();
	}
};
</script>

<template>
	<div class="back-button flex items-center justify-center cursor-pointer" @click="handleClick">
		<ion-icon :icon="icon || chevronBackOutline" class="back-icon text-[24px]" :class="iconClass"></ion-icon>
	</div>
</template>

<style lang="scss" scoped>
.back-button {
	min-width: 44px;
	min-height: 44px;
	padding: 8px;
	margin: -8px;
}

.back-icon {
}
</style>
